import React from 'react';
import { Box } from '@qga/roo-ui/components';

import useBreakpoints, { isScreen } from '@/hooks/useBreakpoints';
import usePropertyContent from '@/hooks/usePropertyContent';
import ImageGallery from '@/shared/components/ImageGallery';

const ImageBanner = React.memo(() => {
  const propertyContent = usePropertyContent();
  const breakpoints = useBreakpoints();
  const isSmallScreen = isScreen(breakpoints)('xs');
  return (
    <Box
      height={[null, null, '490px']}
      position="relative"
      borderRadius={[null, null, '12px']}
    >
      <Box
        mx="auto"
        maxWidth={[null, null, '1248px']}
        width="100%"
        position={['relative', null, 'absolute']}
        height={['280px', null, '100%']}
        left="0"
        right="0"
        top="0"
        bottom="0"
      >
        <ImageGallery
          images={propertyContent.images}
          borderStyle={'round'}
          layout="4-side"
          mediaCounterStyle={isSmallScreen ? 'counter' : 'button'}
        />
      </Box>
    </Box>
  );
});

export default ImageBanner;
